import styled from "styled-components";
import { OneList } from "../../styles/common";
import theme from "../../styles/theme";
import { useCallback, useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import { useSetCounterKey } from "../../interfaces/carsClass";
import { useQueryClient } from "react-query";
import { MODAL_QUERY_NM } from "../../interfaces/modal";

const CounterKeyDetail = ({mode, cnt_no,countersKey:target}) => {

    const queryClient = useQueryClient();

    const [countersKey, setCountersKey] = useState();

    const { mutate } = useSetCounterKey();

    useEffect(()=>{
        setCountersKey(target);
    },[target])

    const handleInitClick = useCallback((updateItem) => {
        const temp = {
            mode: 'DELETE',
            cnt_no: cnt_no
        }
        mutate(
            temp,
            {
                // onSuccess:(res)=>{
                //     queryClient.setQueryData(
                //         [MODAL_QUERY_NM],
                //         {
                //             show:true,
                //             msg:(updateItem.cnt_no>0 ? '수정':'등록')+'하였습니다.',
                //             height:'20vh',
                //         }
                //     )
                //     close();
                // }
            }
            )
    })

    return (
        <div className="detail">
            <OneList style={{height:'auto'}}>
                <ul className="titleLine">
                    <li>
                        <span/>
                        <span>단축키설정</span>
                    </li>
                </ul>
                <ul className="descArea">
                    {countersKey && countersKey.map((item,index)=>{
                        return <CounterKeyItem mode={mode} key={index} index={index+1} item={item} />}
                    )}
                </ul>
            </OneList>
            {mode !== 'VIEW' &&
            <Button variant='contained' onClick={handleInitClick}>초기화</Button>
            }
        </div>
    )
}

const CounterKeyItemWrap = styled.li`
    width: 100%;
    display: grid;
    grid-template-columns: 1rem 2rem 6rem 14rem;
    align-items: center;
    font-size: 1rem;
    border-bottom: 1px solid ${theme.color.black[20]};
    .textfield{
        margin: 0.25rem 0;
    }

`;

const CounterKeyItem = ({mode, index, item}) => {

    const [keyVal, setKeyVal] = useState();

    const { mutate } = useSetCounterKey();

    useEffect(()=>{
        setKeyVal((item && item.code)?{key:String.fromCharCode(item.code),code:item.code}:{key:'',code:''});
    },[item])

    const handleSubsClick = useCallback((obj)=>{
        const temp = {
            mode: 'PUT',
            kno: item.kno,
            code: obj.code
        }
        mutate(
            temp,
            {}
        )
    })

    return (
        <CounterKeyItemWrap>
            <span />
            <span>{index}</span>
            <span>{item.car_tm}</span>
            <div className="textfield">
                <TextField
                    id='code'
                    size="small"
                    style={{width:'6rem'}} 
                    value={keyVal && keyVal.key}
                    InputLabelProps={{shrink:true}}
                    disabled={mode==='VIEW'?true:false}
                    onKeyDown={(e)=>handleSubsClick({key:e.key, code:e.keyCode})}
                />
            </div>
        </CounterKeyItemWrap>
    )
}

export default CounterKeyDetail;